import * as React from "react";
import { Stack } from "@mui/material";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useXoraiaValue } from "../../hooks/useXoraia";
import { TUseXElement, useXElement } from "../../hooks/useXElement";
import { USE_SELECTED_INDEX } from "../../hooks/useSelectedElement";
import { useSetRecoilState } from "recoil";
import { getValueOnBreakpoint } from "../../lib/getValueOnBreakpoint";
import { clickHandler } from "../../lib/clickHandler";
import { XElementConfig } from "../../utils/interfaces/Elements/XElement.interfaces";

import { isEqual } from "lodash";

import { generateSide } from "../../lib/generateSide";
import {
  IXMapProps,
  XMapProps,
} from "../../utils/interfaces/Elements/XMap.interfaces";
import { getMapSrc } from "../../lib/getMapSrc";
import { generateBorder } from "../../lib/generateBorder";
import { generateRadius } from "../../lib/generateRadius";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XMap: React.FC<XMapProps> = React.memo(
  ({ config = {} as XElementConfig }) => {
    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    const { env } = useXoraiaValue();

    // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
    const { xElement } = useXElement<TUseXElement<IXMapProps>>(config.index);

    // GARBING THE INDEX UPDATER FOR GENERAL USAGE
    const setSelectedElement = useSetRecoilState(USE_SELECTED_INDEX);

    // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
    if (!xElement || Object.keys(xElement).length === 0) return null;

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xElement;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXMapProps>(
      value as any,
      breakpoint
    );

    const devProps = {
      id: config.index,
      onClick: (e: any) => clickHandler(e, setSelectedElement, config.index),
    };

    const {
      src,
      width,
      height,
      padding,
      margin,
      border,
      borderRadius,
      bgColor,
      // TODO IMPLEMENT BORDER RADIUS
    } = valueAtBreakPoint;

    // if (!src && env === "prod") return null;

    const map = (
      <iframe
        src={getMapSrc(src)}
        width="auto"
        height="auto"
        style={{
          padding: generateSide("padding", padding) as string,
          margin: generateSide("margin", margin) as string,
          width: width ? (width.includes("%") ? "100%" : width) : "auto",
          height: height ? (height.includes("%") ? "100%" : height) : "auto",
          border: generateBorder(border) ?? "none",
          borderRadius: generateRadius(borderRadius),
          backgroundColor: bgColor,
          pointerEvents: env === "dev" ? "none" : "all",
        }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    );

    if (env !== "prod") {
      return (
        <Stack
          position="relative"
          {...(env === "dev" && devProps)}
          sx={{
            ...valueAtBreakPoint,
            border: "none",
            width: width
              ? width.includes("%")
                ? width
                : "max-content"
              : "100%",
            height: height
              ? height.includes("%")
                ? height
                : "max-content"
              : "auto",
          }}
        >
          {map}
        </Stack>
      );
    }

    return map;
  },
  compareProps
);

export default XMap;
